import { Box, Typography, useTheme } from '@mui/material';

interface SiteInfoBoxProps {
  name: string;
  price: number | null;
  rating: number | null;
  count: number | null;
  url: string | null;
}

export const SiteInfoBox = ({ name, price, rating, count, url }: SiteInfoBoxProps) => {
  const theme = useTheme();

  const getSiteColor = (siteName: string) => {
    const lower = siteName.toLowerCase();
    if (lower.includes('amazon')) return theme.palette.siteColors.amazon;
    if (lower.includes('rakuten')) return theme.palette.siteColors.rakuten;
    if (lower.includes('yahoo')) return theme.palette.siteColors.yahoo;
    return theme.palette.text.primary;
  };

  return (
    <Box
      component="a"
      href={url ?? undefined}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'block',
        minWidth: 0,
        textDecoration: 'none',
        color: 'inherit',
        borderRadius: 1,
        py: 1.5,
        transition: 'background-color 0.2s',
        textAlign: 'center',
        overflow: 'hidden',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      }}
    >
      {/* サイト名 */}
      <Typography
        variant="body2"
        noWrap
        sx={{
          color: getSiteColor(name),
          fontWeight: 'bold',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {name}
      </Typography>

      {/* 価格 */}
      <Typography
        variant="body1"
        fontWeight="bold"
        sx={{
          mt: 0.5,
          whiteSpace: 'nowrap',
        }}
      >
        {(price ?? 0).toLocaleString()} <Box component="span" sx={{ fontSize: '0.75rem' }}>円</Box>
      </Typography>

      {/* 評価/評価数 */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.1,
          whiteSpace: "nowrap",
        }}
      >
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
          <Box component="span" sx={{ color: theme.palette.scoreText.average }}>★</Box>
          {rating}
        </Typography>

        {count != null && (
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.text.secondary,
              whiteSpace: "nowrap",
            }}
          >
            （{count}件）
          </Typography>
        )}
      </Box>
    </Box>
  );
};
